/**
 * Frontend logging utility
 * Provides consistent logging with environment-aware behavior
 */

const isDevelopment = process.env.NODE_ENV === 'development';

const logger = {
  /**
   * Log info messages (only in development)
   */
  info: (...args) => {
    if (isDevelopment) {
      console.log('[INFO]', ...args);
    }
  },

  /**
   * Log debug messages (only in development)
   */
  debug: (...args) => {
    if (isDevelopment) {
      console.log('[DEBUG]', ...args);
    }
  },

  /**
   * Log warnings (always logged)
   */
  warn: (...args) => {
    console.warn('[WARN]', ...args);
  },

  /**
   * Log errors (always logged, but can be enhanced with error tracking)
   */
  error: (...args) => {
    console.error('[ERROR]', ...args);
    // In production, you might want to send errors to an error tracking service
    // e.g., Sentry, LogRocket, etc.
  },

  /**
   * Log errors with stack trace
   */
  errorWithStack: (message, error) => {
    console.error('[ERROR]', message, error);
    if (error?.stack && isDevelopment) {
      console.error('[STACK]', error.stack);
    }
  }
};

export default logger;

